import { Box, Typography } from "@mui/material";
import { colors } from "../../../../theme/palette";
import { EmptyListFigure } from "../../../../assets/icons/MUI/EventsIcons";
import { useTranslation } from "react-i18next";

const EmptyFollowersListFigure = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
    >
      <EmptyListFigure />
      <Typography
        variant="body14Regular"
        sx={{
          color: colors.Dark600,
        }}
      >
        {t("pages.events.createEvent.noFollowers")}
      </Typography>
      <Typography
        variant="body14Regular"
        sx={{
          color: colors.Dark600,
        }}
      >
        {t("pages.events.createEvent.adjustSearchExplore")}
      </Typography>
    </Box>
  );
};

export default EmptyFollowersListFigure;
